// extracted by mini-css-extract-plugin
module.exports = {"base":"Spinner_base__2nbC8","spin":"Spinner_spin__3inKZ","rotate":"Spinner_rotate__1ZudN","center":"Spinner_center__dBUg3","rotateCentered":"Spinner_rotateCentered__3ex3m"};